import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20background%20with%20soft%20beige%20cream%20and%20sand%20organic%20flowing%20shapes%2C%20gentle%20gradient%20texture%20layers%2C%20clean%20modern%20aesthetic%2C%20peaceful%20calm%20atmosphere%2C%20editorial%20quality%20composition%2C%20soft%20diffused%20lighting%2C%20harmonious%20warm%20neutral%20palette%2C%20minimal%20design%20with%20subtle%20depth%2C%20no%20text&width=1920&height=800&seq=cta-bg-v2-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/90 via-secondary-950/70 to-secondary-950/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center lg:items-start justify-between gap-10 max-w-5xl mx-auto">
          <div className="lg:max-w-lg">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
              Ready to Explore the ACBuy Spreadsheet?
            </h2>
            <p className="text-secondary-300 text-sm md:text-base leading-relaxed">
              Access the full ACBuy spreadsheet database with thousands of verified products,
              real-time pricing, and honest buyer ratings — all in one place.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4 flex-shrink-0">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
            >
              Open ACBuy Spreadsheet Database
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <Link
              to="/article/acbuy-spreadsheet-guide"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 border-2 border-background-50/30 hover:bg-background-50/10 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Read Full Guide
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}